var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
    },
    [
      _vm.isNavigationInitialized
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "mobile-nav-header d-flex justify-content-center",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "btn-close",
                    on: {
                      click: function ($event) {
                        return _vm.closeNavigation()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa-light fa-xmark",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                !_vm.isLoggedIn
                  ? _c(
                      "a",
                      {
                        staticClass: "hProfile",
                        attrs: {
                          "data-testing": "login-select",
                          href: _vm.isLogin ? "javascript:void(0)" : "#login",
                          "data-toggle": _vm.isLogin ? false : "modal",
                          "aria-label": _vm.$translate("Ceres::Template.login"),
                        },
                        on: {
                          click: function ($event) {
                            _vm.createLoginModal()
                            _vm.unmarkInputFields()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-user-large hAccIcon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hProfile" }, [
                          _vm._v(
                            _vm._s(_vm.$translate("Ceres::Template.login"))
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLoggedIn
                  ? _c(
                      "a",
                      {
                        staticClass: "dropdown-toggle nav-link",
                        attrs: { href: "#" },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-square-user hAccIcon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "d-none d-sm-inline" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.loginHello", {
                                username: _vm.username,
                              })
                            )
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-nav-content" }, [
              !_vm.selectedCategory
                ? _c("div", { staticClass: "mobile-nav-group-title" }, [
                    _vm._v("\n                Alle Kategorien\n            "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [{ name: "menu", rawName: "v-menu" }],
                  staticClass: "mainmenu w-100 p-0 m-0 menu-active",
                  attrs: { id: "menu-1" },
                },
                [
                  _vm.dataContainer1.parent
                    ? _c(
                        "li",
                        {
                          staticClass: "ddown mobile-nav-breadcrumb-container",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(
                                (_vm.dataContainer1.parent &&
                                  _vm.dataContainer1.parent.parent) ||
                                  null,
                                true
                              )
                            },
                          },
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _vm.parentCategory
                            ? _c(
                                "div",
                                { staticClass: "mobile-nav-breadcrumb" },
                                [_vm._v(_vm._s(_vm.parentCategory.name))]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.dataContainer1.categories, function (category) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c(
                        "a",
                        { attrs: { href: _vm.getCategoryUrl(category.url) } },
                        [_vm._v(_vm._s(category.details[0].name))]
                      ),
                      _vm._v(" "),
                      category.childCount
                        ? _c(
                            "span",
                            {
                              staticClass: "nav-direction",
                              on: {
                                click: function ($event) {
                                  return _vm.slideTo(category)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-light fa-angle-right",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.dataContainer1.categories[0]
                    ? _vm._l(
                        _vm.dataContainer1.categories[0].siblingCount -
                          _vm.dataContainer1.categories.length,
                        function (number) {
                          return _c("li", { staticClass: "ddown" }, [
                            _c("span", {
                              staticClass: "nav-placeholder m-3",
                              style: { width: Math.random() * 20 + 60 + "%" },
                            }),
                          ])
                        }
                      )
                    : _vm.dataContainer1.parent
                    ? _vm._l(
                        _vm.dataContainer1.parent.childCount,
                        function (number) {
                          return _c("li", { staticClass: "ddown" }, [
                            _c("span", {
                              staticClass: "nav-placeholder m-3",
                              style: { width: Math.random() * 20 + 60 + "%" },
                            }),
                          ])
                        }
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [{ name: "menu", rawName: "v-menu" }],
                  staticClass: "mainmenu w-100 p-0 m-0",
                  attrs: { id: "menu-2" },
                },
                [
                  _vm.dataContainer2.parent
                    ? _c(
                        "li",
                        {
                          staticClass: "ddown mobile-nav-breadcrumb-container",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(
                                (_vm.dataContainer2.parent &&
                                  _vm.dataContainer2.parent.parent) ||
                                  null,
                                true
                              )
                            },
                          },
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _vm.parentCategory
                            ? _c(
                                "div",
                                { staticClass: "mobile-nav-breadcrumb" },
                                [_vm._v(_vm._s(_vm.parentCategory.name))]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.dataContainer2.categories, function (category) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c(
                        "a",
                        { attrs: { href: _vm.getCategoryUrl(category.url) } },
                        [_vm._v(_vm._s(category.details[0].name))]
                      ),
                      _vm._v(" "),
                      category.childCount
                        ? _c(
                            "span",
                            {
                              staticClass: "nav-direction",
                              on: {
                                click: function ($event) {
                                  return _vm.slideTo(category)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-light fa-angle-right",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.dataContainer2.categories[0]
                    ? _vm._l(
                        _vm.dataContainer2.categories[0].siblingCount -
                          _vm.dataContainer2.categories.length,
                        function (number) {
                          return _c("li", { staticClass: "ddown" }, [
                            _c("span", {
                              staticClass: "nav-placeholder m-3",
                              style: { width: Math.random() * 20 + 60 + "%" },
                            }),
                          ])
                        }
                      )
                    : _vm.dataContainer2.parent
                    ? _vm._l(
                        _vm.dataContainer2.parent.childCount,
                        function (number) {
                          return _c("li", { staticClass: "ddown" }, [
                            _c("span", {
                              staticClass: "nav-placeholder m-3",
                              style: { width: Math.random() * 20 + 60 + "%" },
                            }),
                          ])
                        }
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c(
              "div",
              {
                staticClass: "mobile-nav-header d-flex justify-content-center",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "btn-close",
                    on: {
                      click: function ($event) {
                        return _vm.closeNavigation()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa-light fa-xmark",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                !_vm.isLoggedIn
                  ? _c(
                      "a",
                      {
                        staticClass: "hProfile",
                        attrs: {
                          "data-testing": "login-select",
                          href: _vm.isLogin ? "javascript:void(0)" : "#login",
                          "data-toggle": _vm.isLogin ? false : "modal",
                          "aria-label": _vm.$translate("Ceres::Template.login"),
                        },
                        on: {
                          click: function ($event) {
                            _vm.createLoginModal()
                            _vm.unmarkInputFields()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-user-large hAccIcon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hProfile" }, [
                          _vm._v(
                            _vm._s(_vm.$translate("Ceres::Template.login"))
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLoggedIn
                  ? _c(
                      "a",
                      {
                        staticClass: "dropdown-toggle nav-link",
                        attrs: { href: "#" },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-square-user hAccIcon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "d-none d-sm-inline" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.loginHello", {
                                username: _vm.username,
                              })
                            )
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mobile-nav-content" },
              [_c("loading-animation")],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa-light fa-arrow-left",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa-light fa-arrow-left",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }